<template>
	
</template>

<script>
	export default {
		mounted() {
			$(this.$refs['modal']).modal({
    			closable: false,
    			onDeny: () => {
      				this.$root.$emit('close-popup', this);
    			},
    			onApprove: () => {
    				if (this.$refs['cookie-check'] && this.$refs['cookie-check'].checked) {
						let cookieName = this.$refs['cookie-check'].name;
						this.$cookies.set(cookieName, true, 60 * 60 * 24 * 30);
					}
      				this.$root.$emit('close-popup', this);
    			},
    			onHide: () => {
    				this.$root.$emit('close-popup', this);
    			}
  			});

			if (this.$refs['cookie-check']) {
				let cookieName = this.$refs['cookie-check'].name;
				if (!this.$cookies.isKey(cookieName) && !this.$cookies.isKey(cookieName + '_once')) {
					this.open();
				} else {
					this.onCookiePresent();
				}
			} else {
				this.open();
			}
		},
		beforeDestroy() {
		},
		methods: {
			open() {
				$(this.$refs['modal']).modal('show');
			},
			onCookiePresent() { }
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/modals/Popup.vue